import { 
    FETCH_ROUTES,
    FETCH_ROUTES_SUCCESS,
    FETCH_ROUTES_FAILED,
  } from "../actions/types";
  
  export const INITIAL_STATE = {
    routes:null,
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_ROUTES:
        return {
          ...state,
          loading:true
        };
      case FETCH_ROUTES_SUCCESS:
        return {
          ...state,
          routes:action.payload,
          loading:false
        };
      case FETCH_ROUTES_FAILED:
        return {
          ...state,
          bookings:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      default:
        return state;
    }
  };